import React from 'react';

export function TopNav({ brand, links = [], actions, activeHref, className = '', ...rest }) {
  return (
    <header className={['sp-topnav', className].filter(Boolean).join(' ')} {...rest}>
      {brand && <div style={{ flex: 'none', display: 'flex', alignItems: 'center' }}>{brand}</div>}
      <nav className="sp-topnav__links">
        {links.map((l, i) => (
          <a
            key={(l.href || '') + String(l.label) + i}
            href={l.href || '#'}
            onClick={l.onClick}
            className={['sp-topnav__link', (l.active || l.href === activeHref) && 'sp-topnav__link--active'].filter(Boolean).join(' ')}
          >{l.label}</a>
        ))}
      </nav>
      {actions && <div className="sp-topnav__actions">{actions}</div>}
    </header>
  );
}
